export default __webpack_public_path__ + "static/media/meeting_filter_arrow_down.3310406f.svg";